import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { ResultsMessage } from 'foundations-components/transitional/components/ResultsMessage';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const EditorNoResultsMessage = props => {
  const {
    message
  } = props;
  return /*#__PURE__*/_jsx(View, {
    margin: "auto",
    as: "div",
    children: /*#__PURE__*/_jsx(ResultsMessage, {
      illustration: "empty-state-charts",
      margin: "0",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: message
      })
    })
  });
};
export default EditorNoResultsMessage;